<template>
  <div class="swiper-container">
      <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="slide in slides" :style="{backgroundImage:'url('+slide+')'}"  :class="{'swiper-no-swiping': slides.length==1}"></div>
      </div>
      <div class="swiper-pagination" v-if="slides.length > 1"></div>
  </div>
</template>
<script>
  import Swiper from 'swiper'
  import 'swiper/dist/css/swiper.css'
  export default {
    data(){
      return {
        loop: false,
        autoplay: 0
      }
    },
    props: {
      slides: {
        type: Array,
        default: []
      }
    },
    methods: {
      init(){
      }
    },
    mounted(){
      let loop = this.slides.length > 1;
      let autoplay = loop ? 6000 : 0;
      new Swiper(this.$el, {
        autoplay: autoplay,
        loop: loop,
        noSwiping: true,
        pagination: '.swiper-pagination'
      })
    }
  }
</script>

<style lang="less" scoped>
  .swiper-wrapper{z-index:-1;}
  .swiper-container{
    position: absolute;
    left: 0;
    right: 0;
    top:0;
    bottom: 0;
    z-index: -1;
    border-radius:50%;
    overflow:hidden;
    transform: translate3d(0,0,0);
    transform-style:preserve-3d;
    -webkit-mask-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYGBgAAgwAAAEAAGbA+oJAAAAAElFTkSuQmCC); /* this fixes the overflow:hidden in Chrome/Opera */
  }
  .swiper-slide{border-radius: 50%;z-index:-1;background: center center no-repeat;background-size:cover;}
</style>



// WEBPACK FOOTER //
// swiper.vue?6b2bea45